export const TITLE_PREFIX = 'РГК «Сити Парк» - '


// WEBPACK FOOTER //
// ./src/appConstants.js